import type { ViewInformationModalProps } from '../../../config/modalConfig';
import ShoppingBasketGovernmentFeeText from './ShoppingBasketGovernmentFeeText';
import type { FeeDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/quote/submission/dto/';
import { useHippoText } from '../../../hooks/useHippoText';
import { useRecoilValue } from 'recoil';
import { jobAtom } from '../../../recoil/atoms/jobAtom';
import { accountHolderAtom } from '../../../recoil/atoms/accountHolderAtom';

const ShoppingBasketGovernmentFee = ({
    governmentFees
}: {
    governmentFees: FeeDTO[];
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const jobData = useRecoilValue(jobAtom);
    const { isCVR } = useRecoilValue(accountHolderAtom);
    const viewInformationModalContentMap: Record<string, ViewInformationModalProps> = {
        'Naturskadeafgift til staten': {
            title: getHippoText('top-online-sales.governmentFeeModal.FloodAndHurricaneFeeTitle'),
            description: getHippoText(
                'top-online-sales.governmentFeeModal.FloodAndHurricaneFeeContent'
            )
        },
        'Bidrag til Garantifonden': {
            title: getHippoText('top-online-sales.governmentFeeModal.GuaranteeFeeTitle'),
            description: getHippoText('top-online-sales.governmentFeeModal.GuaranteeFeeContent')
        },
        'Bidrag til Garantifonden for Arbejdsskadeforsikring': {
            title: getHippoText('top-online-sales.governmentFeeModal.GuaranteeFeeWorkersCompTitle'),
            description: getHippoText(
                'top-online-sales.governmentFeeModal.GuaranteeFeeWorkersCompContent'
            )
        },
        'Bidrag til Fonden for motoransvarsforsikringer': {
            title: getHippoText('DSS-GOVERNMENT-FEE-MOTOR-INSURANCE-FUND-TITLE'),
            description: getHippoText('DSS-GOVERNMENT-FEE-MOTOR-INSURANCE-FUND-DESCRIPTION')
        }
    };
    return (
        <div>
            {jobData.selectedPaymentFrequency === 'onetime' ? (
                <p className={'paragraph--small u-color-secondary-4-medium'}>
                    {getHippoText('DSS-SUMMARY-GOVERNMENT-FEE-HEADER-SINGLEPAYMENT')}
                </p>
            ) : (
                <p className={'paragraph--small u-color-secondary-4-medium'}>
                    {getHippoText(
                        isCVR
                            ? 'DSS-SUMMARY-CVR-GOVERNMENT-FEE-HEADER'
                            : 'DSS-SUMMARY-GOVERNMENT-FEE-HEADER'
                    )}
                </p>
            )}
            <div className="u-spacing-inset-m--stretch-max">
                {governmentFees.map((fee) => {
                    return (
                        <ShoppingBasketGovernmentFeeText
                            key={fee.feeName}
                            fee={fee}
                            modalProps={viewInformationModalContentMap[fee.feeName ?? '']}
                        />
                    );
                })}
            </div>
            {jobData.selectedPaymentFrequency === 'monthly' ? (
                <p className={'paragraph--small u-color-secondary-4-medium u-spacing-stack-none'}>
                    {getHippoText(
                        isCVR
                            ? 'DSS-SUMMARY-CVR-GOVERNMENT-FEE-PAYMENT'
                            : 'DSS-SUMMARY-GOVERNMENT-FEE-PAYMENT'
                    )}
                </p>
            ) : (
                <hr className="u-border-primary-1-base" />
            )}
        </div>
    );
};

export default ShoppingBasketGovernmentFee;
